export abstract class AnalyticsAdapter {
  isEnabled: boolean = false;
  abstract identify(userId: string): void;
  abstract track(eventName: string, data?: any): void;
  abstract page(pageName: string, pageData?: any): void;
}
